import { useEffect } from "react";
import { Spin, Typography } from "antd";
import { LinkOutlined } from "@ant-design/icons";

interface Props {
  config: { url: string };
}

const PublicWebsite = ({ config }: Props) => {
  useEffect(() => {
    if (config?.url) {
      window.location.replace(config.url);
    }
  }, [config]);

  return (
    <div className="flex flex-col h-full items-center justify-center gap-4 p-8 text-center">
      <Spin size="large" />
      <LinkOutlined style={{ fontSize: 32, color: "#1677ff" }} />
      <Typography.Text type="secondary">Đang chuyển hướng tới website...</Typography.Text>
      {config?.url && (
        <Typography.Link href={config.url} target="_blank">
          {config.url}
        </Typography.Link>
      )}
    </div>
  );
};

export default PublicWebsite;
